export default "__VITE_ASSET__DaVKpHdf__"